import {
  NON_VOLUNTEER_TEAM_VOLUNTEER_ACTIVITY_TYPES,
  type VolunteerActivityType,
} from '@/queries/constants'
import type { UserContextType } from '@/client/context/user'
import {
  AUTOMATICALLY_LOGGED_VOLUNTEER_ACTIVITIES_SET,
  canUserSubmitNonTeamVolunteerActivity,
  VOLUNTEER_ACTIVITY_TO_LABEL,
  VOLUNTEER_TEAM_SLUG_TO_ACTIVITY_TYPE,
} from '@/client/services/volunteerActivity'

import type { Options } from '@/components/UI/Form/types'

function createSelectOptionsFromActivities(activities: VolunteerActivityType[]): Options {
  return (
    activities
      .map(activity => ({
        value: activity,
        label: VOLUNTEER_ACTIVITY_TO_LABEL[activity],
      }))
      // sort alphabetically, with 'Other' at the end.
      .sort((a, b) => (a.value === 'other' ? 100 : a.label < b.label ? -1 : 1))
  )
}

const TYPES_TO_FILTER = new Set<VolunteerActivityType>(['coda-hours'])
export function nonVolunteerRoleActivityOptions(
  user: UserContextType,
  defaultType?: VolunteerActivityType | null
): Options {
  return createSelectOptionsFromActivities(
    Array.from(
      new Set([
        // Only display options that the user has scope to choose.
        ...NON_VOLUNTEER_TEAM_VOLUNTEER_ACTIVITY_TYPES.filter(
          activity =>
            !AUTOMATICALLY_LOGGED_VOLUNTEER_ACTIVITIES_SET.has(activity) &&
            canUserSubmitNonTeamVolunteerActivity(user, activity) &&
            !TYPES_TO_FILTER.has(activity)
        ),
        // Some activities are automatically logged. In the case that this
        // is an automatically-created activity, inject the type.
        ...(defaultType != null ? [defaultType] : []),
      ])
    )
  )
}

export function volunteerTeamActivityOptions(teamSlugs: string[]): Options {
  const activityTypes = teamSlugs
    .map(slug => VOLUNTEER_TEAM_SLUG_TO_ACTIVITY_TYPE[slug])
    .filter(type => type != null && !AUTOMATICALLY_LOGGED_VOLUNTEER_ACTIVITIES_SET.has(type))
  return createSelectOptionsFromActivities(activityTypes)
}
